/** Shapes only the new canvas draws, mapped to the closest one Cytoscape has. */
const CYTOSCAPE_FALLBACK: Record<string, string> = {
  CAPSULE: 'ROUND-RECTANGLE',
  CYLINDER: 'BARREL',
  DOCUMENT: 'RECTANGLE',
  PERSON: 'ELLIPSE',
  CLOUD: 'ELLIPSE',
  CHEVRON: 'TAG',
  'SPEECH-BUBBLE': 'ROUND-RECTANGLE',
  'STRAIGHT-ELLIPSE': 'ELLIPSE',
};

/** The stored node type as v1 draws it, upper case. */
export function cyNodeType(type: string | null | undefined): string {
  const key = String(type || 'ELLIPSE').toUpperCase();
  return CYTOSCAPE_FALLBACK[key] ?? key;
}

/** The Cytoscape `shape` style value for a stored node type. */
export function cyNodeShape(type: string | null | undefined): string {
  return cyNodeType(type).toLowerCase();
}
